import {shumaType} from '../../../common/constants/shumaType';

export const getStep12Title = shumaTypeID => {
  switch (shumaTypeID) {
    case shumaType.BANK_CODE_19:
      return 'תקן 19';
    case shumaType.BANK_FULL:
      return 'מקוצרת';
    case shumaType.BANK_SHORT:
      return 'מורחבת';
    default:
      return '';
  }
}
